import NetFlix from 'assets/partners/netflix.png'
import DBC from 'assets/partners/dbc.png'
import HULU from 'assets/partners/hulu.png'
import LifeTime from 'assets/partners/lifetime.png'
import MissAmerica from 'assets/partners/miss-america.png'
import People from 'assets/partners/people.png'
import VanityFair from 'assets/partners/vanity-fair.png'
import WomenBean from 'assets/partners/women-bean.png'

export const PartnerIcons = [
    {
        src: LifeTime
    },
    {
        src: NetFlix
    },
    {
        src: DBC
    },
    {
        src: MissAmerica
    },
    {
        src: HULU
    },
    {
        src: VanityFair
    },
    {
        src: People
    },
    {
        src: WomenBean
    }
]